import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { get } from 'underscore';
import { isValidUrl } from '@bingads-webui/url-util';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { TextField } from '@fluentui/react';
import { URL_LENGTH_LIMIT } from '../helpers/constants';
import { withHttpsPrefix } from '../helpers/utils';

const UrlInput = memo(({
  className,
  i18n,
  validationProps,
  updateValidation,
  placeholder,
}) => {
  const input = get(validationProps, ['data', 'input'], '');

  const validateAndUpdateUrl = useCallback((value) => {
    const finalUrlValidatorErrors = [];
    const fullUrl = value.indexOf('://') >= 0 ? value : withHttpsPrefix(value);
    if (!value || !isValidUrl(fullUrl)) {
      finalUrlValidatorErrors.push(i18n.getString(_TL_('Please enter a valid URL')));
    }
    if (value.length > URL_LENGTH_LIMIT) {
      finalUrlValidatorErrors.push(i18n.getString(_TL_('The number of characters in this field cannot exceed {{lengthLimit}}'), { lengthLimit: URL_LENGTH_LIMIT }));
    }
    updateValidation(finalUrlValidatorErrors, { input: value });
  }, [i18n, updateValidation]);

  const onTextChange = useCallback((ev, value) => validateAndUpdateUrl(value), [validateAndUpdateUrl]);

  return (
    <TextField
      className={className}
      value={input}
      onChange={onTextChange}
      placeholder={placeholder}
    />
  );
}, (prevProps, nextProps) => prevProps.validationProps.data.input === nextProps.validationProps.data.input);

UrlInput.propTypes = {
  className: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      input: PropTypes.string,
    }),
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

UrlInput.defaultProps = {
  className: '',
  placeholder: '',
};

export const ValidatedUrlInput = withCustomValidation(UrlInput);
